import QrCode from './Index.vue'

QrCode.install = function(Vue) {
  Vue.component(QrCode.name, QrCode)
}

export default QrCode
